import { Card } from "react-bootstrap";
import i18n from "i18next";
import { ResolvedDocumentAttachment } from "../../services/document/DocumentAttachmentService";
import { PapyrusDocumentRepresentation } from "../../services/document/DocumentModels";

type TextDocumentViewerProps = {
    representation: PapyrusDocumentRepresentation;
    resolvedAttachment?: ResolvedDocumentAttachment;
};

export default function TextDocumentViewer({ representation, resolvedAttachment }: TextDocumentViewerProps) {
    return (
        <Card>
            <Card.Body>
                <Card.Title>{i18n.t("viewer.text")}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {representation.contentType}
                </Card.Subtitle>
                {resolvedAttachment?.text ? (
                    <pre className="bg-light p-3 border rounded overflow-auto">
                        {resolvedAttachment.text}
                    </pre>
                ) : resolvedAttachment?.sourceUrl || resolvedAttachment?.objectUrl ? (
                    <iframe
                        title={representation.id}
                        src={resolvedAttachment.sourceUrl ?? resolvedAttachment.objectUrl}
                        style={{ width: "100%", minHeight: "70vh", border: 0 }}
                    />
                ) : (
                    <Card.Text>{i18n.t("viewer.notext")}</Card.Text>
                )}
            </Card.Body>
        </Card>
    );
}
